import React, { useEffect, useRef, useState } from "react";

import ArrowRightBigIcon from "images/icons/arrow-right-big-icon.inline.svg";
import ArrowRight from "images/icons/arrow-right.inline.svg";
import CloseIcon from "images/icons/close-outline.inline.svg";

import ContactForm from "../../components/forms/contact";
import Modal from "../../components/shared/modal";
import ModalInPortal from "../shared/modals/modalInPortal";
import ShareBtn from "../shared/shareBtn";
import ParentInfoIntroDetails from "./ParentInfoIntroDetails";

const ParentMainInfo = ({
  introText,
  parentInformationDetails,
  openModal,
  setOpenModal,
  programCode,
  formType = "parent_request",
  displayInline = true,
  modalConfig = {
    ctaLabel: "Enquire",
    formHeading: "Free parent consultation",
    formSubheading:
      "You have questions and we'd love to answer them. Talk to us about any of our education and adventure programs, locations, health and safety protocols, travel arrangements, or anything else that's on your mind. We're here to help. Fill out your details below and we'll be in touch."
  }
}) => {
  const [modalProcessingStatus, setModalProcessingStatus] = useState("");

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const hiddenFields = [{ fieldName: "program_id", fieldValue: programCode }];

  const [shareUrl, setShareUrl] = useState();
  const shareBtnRef = useRef();

  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    setShareUrl(encodeURI(location?.href ?? "#"));
  }, []);

  return (
    <div className="parent-main__info">
      {displayInline && (
        <>
          {introText?.title && (
            <div className="relative flex justify-between">
              <h1
                className="font-light text-black-lighter planet:text-white leading-9"
                dangerouslySetInnerHTML={{ __html: introText.title }}
              />

              <div className="sm:hidden flex items-center">
                <ShareBtn url={shareUrl} ref={shareBtnRef} />
              </div>
            </div>
          )}

          {parentInformationDetails && (
            <ParentInfoIntroDetails
              parentInformationDetails={parentInformationDetails}
            />
          )}

          {introText?.description && (
            <div className="relative flex justify-between">
              <div
                className="py-8 basis-full sm:basis-11/12 md:text-base text-black-lighter planet:text-gray-generic text-[0.9375rem] leading-[1.225rem]"
                dangerouslySetInnerHTML={{
                  __html: introText.description
                }}
              />
              <div className="hidden sm:flex absolute right-0 items-center justify-end cursor-pointer sm:top-10 basis-12 pr-6">
                <ShareBtn url={shareUrl} ref={shareBtnRef} />
              </div>
            </div>
          )}

          <div className="flex w-full sm:w-1/3">
            <button
              onClick={() => {
                setOpenModal(true);
              }}
              className="submit-button group flex items-center mt-2 justify-center py-2 w-full"
            >
              Free parent consultation
              <span className="ml-4">
                <ArrowRight
                  className={`w-3 h-3 stroke-gray-darker hidden planet:block group-hover:stroke-green-standard`}
                />
                <ArrowRightBigIcon className="fill-white block planet:hidden group-hover:fill-black-lighter" />
              </span>
            </button>
          </div>
        </>
      )}

      {openModal && (
        <ModalInPortal
          openModal={openModal}
          modal={
            <Modal
              closeModal={handleCloseModal}
              modalCloseIcon={
                modalProcessingStatus === "processing" ? (
                  <></>
                ) : (
                  <CloseIcon className="h-5 fill-black-lighter planet:fill-white" />
                )
              }
              modalContentStyles="w-full mx-auto gvi-blur-bg md:bg-yellow-standard md:blur-none planet:gvi-blur-newsletter-bg planet:gvi-blur-bg gvi-border-light border-0.5 border-gray-testimonial rounded-xxs py-3 z-10"
              modalContainerStyles="w-full sm:w-3/5 h-full sm:h-auto"
              modalOuterContainerStyles={
                "fixed top-0 left-0 right-0 overflow-scroll z-20 flex items-center justify-center w-full h-full sm:modalBackground bg-white planet:bg-gray-darkest sm:gvi-modal-light-bg planet:sm:gvi-modal-bg"
              }
              modalCloseBtnStyles="w-full flex justify-end h-auto pr-4 sm:pl-2 sm:hidden"
              modalContent={
                <div className="px-4 pb-16 sm:px-16 sm:pt-4">
                  <ContactForm
                    formType={formType}
                    ctaLabel={modalConfig.ctaLabel}
                    formHeading={modalConfig.formHeading}
                    formSubheading={modalConfig.formSubheading}
                    formStyles="rounded-md w-full mx-auto"
                    hiddenFields={hiddenFields}
                    labelColor={
                      "text-black-lighter sm:text-white planet:text-white"
                    }
                    calendlyActive={false}
                    contactLabelsClass={
                      "text-black-lighter planet:text-white sm:text-white"
                    }
                    setParentStatus={setModalProcessingStatus}
                    iconColor={
                      "text-black-lighter fill-black-lighter planet:fill-white sm:text-white sm:fill-white planet:text-white"
                    }
                    txtColor={
                      "text-black-lighter sm:text-white planet:text-white"
                    }
                    inputStyles={
                      "contact-form-input-white-bg sm:contact-form-input"
                    }
                    checkboxClass="xxxs:border-black-lighter stroke-black-lighter sm:stroke-white planet:stroke-white"
                  />
                </div>
              }
            />
          }
        />
      )}
    </div>
  );
};

export default ParentMainInfo;
